import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

*{
    margin: 0;
    padding:0;
    box-sizing: border-box;
    

}
html{
    scroll-behavior: smooth;
    @media (max-width: 612px){
    font-size: 75%;
    };
}
body{
    font-family: "Lato", sans-serif;
    overflow-x: hidden;
    height: 100vh;
    width: 100vw;
    background: #0c1d36;
   
}
a {
    color: white;
    text-decoration: none;
}
span {
      color: #F9CC0B;

    }

h1{

font-weight: 400
}
p, h4, li{
    font-weight: 300;
    line-height: 4vh;
}

button {
    background: none;
    width: 30rem;
    height: 15vh;
    border-radius: 7.5vh;
    margin: 3vh 3vw;
    border: solid 0.2rem #f9cc0b;
    font-size: 1.8rem;
    color: #f9cc0b;
    backdrop-filter: blur(5px);
    font-weight: 300;
    cursor: pointer;
    @media (max-width: 950px) {
      margin-top: 10vh;
      width: 20rem;
      height: 10vh;
      font-size: 1.5rem;
    }
    &:hover {
      box-shadow: 1px 1px 30px #f9cc0b;
      box-shadow: 1px 1px 45px #f9cc0b;
      text-shadow: 1px 1px 15px #f9cc0b;
      text-shadow: 1px 1px 15px #f9cc0b;

      transition: 0.3s;
    }
    &:focus {
      box-shadow: 1px 1px 30px #f9cc0b;
      box-shadow: 1px 1px 45px #f9cc0b;
      text-shadow: 1px 1px 15px #f9cc0b;
      text-shadow: 1px 1px 15px #f9cc0b;
      transition: 0.5s;
    }
  }


`;

export default GlobalStyle;
